import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
// Añadir MDButton aquí
import MDButton from "shared/components/MDButton"; // ← AÑADE ESTA LÍNEA
import { Card, Snackbar, Alert, CircularProgress, Box, Divider, Grid } from "@mui/material";
import HeaderAutomatization from "./components/HeaderAutomatization";
import { Info, History, CheckCircle } from "@mui/icons-material";

const Informe = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    action: null, // Para acciones personalizadas
  });
  const [loading, setLoading] = useState(false);

  // ========== MANEJO DE NOTIFICACIONES ==========
  const showNotification = (message, severity = "success", options = {}) => {
    setSnackbar({
      open: true,
      message,
      severity,
      action: options.action || null,
      autoHideDuration: options.persist ? null : 6000,
    });
  };

  const showSuccess = (message) => {
    showNotification(message, "success");
  };

  const showError = (message, options = {}) => {
    showNotification(message, "error", options);
  };

  const showWarning = (message) => {
    showNotification(message, "warning");
  };

  const showInfo = (message) => {
    showNotification(message, "info");
  };

  // Manejar cierre del Snackbar
  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // ========== MANEJO DE RESPUESTAS DEL BACKEND ==========
  const handleCreateCycle = async (data) => {
    try {
      // Verificar si hay error en la respuesta
      if (data.error || !data.success) {
        const errorMessage = data.error || data.message || "Error desconocido al crear el ciclo";

        // Mostrar error específico
        showError(errorMessage, {
          persist: errorMessage.includes("sesión") || errorMessage.includes("token"),
          action: errorMessage.includes("conexión") ? (
            <MDButton color="inherit" size="small" onClick={() => window.location.reload()}>
              Reintentar
            </MDButton>
          ) : null,
        });

        return;
      }

      // Si es éxito

      // Refrescar la tabla
      setRefreshFlag((prev) => !prev);

      // Mostrar mensaje personalizado según respuesta del backend
      let successMessage = `Informe creado exitosamente`;

      // Usar mensaje del backend si está disponible
      if (data.backendResult?.message) {
        successMessage = data.backendResult.message;
      }

      // Mostrar éxito con detalles
      showSuccess(successMessage);

      // Mostrar detalles adicionales si el backend los proporciona
      if (data.backendResult?.data) {
        const backendData = data.backendResult.data;

        // Podrías mostrar más detalles aquí si es necesario
        if (backendData.idCycle) {
        }
      }
    } catch (error) {
      console.error("❌ Error al manejar creación de ciclo:", error);

      // Clasificar errores
      let userMessage = "Error al procesar el ciclo creado";
      let severity = "error";
      let persist = false;

      if (error.name === "NetworkError" || error.message.includes("conexión")) {
        userMessage = "No se pudo conectar con el servidor. Verifique su conexión a internet.";
        severity = "warning";
        persist = true;
      } else if (error.message.includes("sesión") || error.message.includes("token")) {
        userMessage = "Su sesión ha expirado. Por favor, inicie sesión nuevamente.";
        persist = true;

        // Redirigir después de 3 segundos
        setTimeout(() => {
          window.location.href = "/auth/login";
        }, 3000);
      } else if (error.message.includes("validación") || error.message.includes("formato")) {
        userMessage = error.message;
        severity = "warning";
      }

      showNotification(userMessage, severity, { persist });
    }
  };

  // Manejar errores desde la tabla con clasificación
  const handleTableError = (errorMessage, errorType = "general") => {
    let severity = "error";
    let persist = false;

    switch (errorType) {
      case "auth":
        severity = "warning";
        persist = true;
        break;
      case "network":
        severity = "warning";
        persist = true;
        break;
      case "validation":
        severity = "warning";
        break;
      case "server":
        severity = "error";
        break;
      default:
        severity = "error";
    }

    showNotification(errorMessage, severity, { persist });
  };

  // ========== MANEJO DE ERRORES DE COMERCIOS ==========
  const handleCommerceError = (error) => {
    console.warn("Error al cargar comercios:", error);

    // No mostrar error si es solo un warning
    if (!error.includes("Error: La respuesta")) {
      showWarning(error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Notificación Snackbar mejorado */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.autoHideDuration || 6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        key={snackbar.message} // Forzar re-render con nuevo mensaje
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          action={snackbar.action}
          sx={{
            width: "100%",
            maxWidth: "500px",
            backgroundColor:
              snackbar.severity === "success"
                ? "#f0fff4"
                : snackbar.severity === "error"
                ? "#fff5f5"
                : snackbar.severity === "warning"
                ? "#fffaf0"
                : "#ebf8ff",
            color:
              snackbar.severity === "success"
                ? "#276749"
                : snackbar.severity === "error"
                ? "#c53030"
                : snackbar.severity === "warning"
                ? "#dd6b20"
                : "#2c5282",
            border:
              snackbar.severity === "success"
                ? "1px solid #c6f6d5"
                : snackbar.severity === "error"
                ? "1px solid #fed7d7"
                : snackbar.severity === "warning"
                ? "1px solid #feebc8"
                : "1px solid #bee3f8",
            boxShadow: 2,
            "& .MuiAlert-icon": {
              color:
                snackbar.severity === "success"
                  ? "#276749"
                  : snackbar.severity === "error"
                  ? "#c53030"
                  : snackbar.severity === "warning"
                  ? "#dd6b20"
                  : "#2c5282",
            },
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success"
              ? "¡Éxito!"
              : snackbar.severity === "error"
              ? "Error"
              : snackbar.severity === "warning"
              ? "Advertencia"
              : "Información"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      {/* Contenido principal */}
      <MDBox py={3}>
        {/* Sección de creación */}
        <MDBox mb={4}>
          <HeaderAutomatization
            onCreateCycle={handleCreateCycle}
            onCommerceError={handleCommerceError}
          />
        </MDBox>

        {/* Separador visual */}
        <MDBox mb={0}>
          <Divider sx={{ borderColor: "rgba(0,0,0,0.1)", borderWidth: 1 }} />
        </MDBox>

        {/* Sección de historial */}
        <MDBox>
          {/* Header del historial */}

          {/* Panel de estado del sistema */}
          <MDBox mt={3} p={2} bgcolor="background.paper" borderRadius="8px">
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <MDBox display="flex" alignItems="center" gap={1}>
                  <CheckCircle fontSize="small" color="success" />
                  <MDTypography variant="caption" color="textSecondary">
                    Estado del sistema: <strong>Operativo</strong>
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={8}>
                <MDTypography variant="caption" color="textSecondary">
                  Última actualización: {new Date().toLocaleTimeString()}
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </MDBox>

      {/* Indicador de carga global */}
      {loading && (
        <MDBox
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgcolor="rgba(255,255,255,0.7)"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={9999}
        >
          <MDBox textAlign="center">
            <CircularProgress color="info" size={60} />
            <MDTypography variant="h6" mt={2}>
              Procesando...
            </MDTypography>
          </MDBox>
        </MDBox>
      )}
    </DashboardLayout>
  );
};

export default Informe;
